import React from 'react';
import { useNavigate, useParams } from 'react-router';
import { notification } from 'antd';

import { useAppDispatch, useAppSelector } from 'store';
import { IArticlesItem } from 'store/slices/articles/interfaces';
import { MainLayout } from 'components/Layout/MainLayout';
import {
  saveArticlesItem,
  loadArticlesItem,
  saveArticlesItemAsDraft,
} from 'store/slices/articles/actions';

import { ArticlesForm } from './components/ArticlesForm';
import { mapValuesToForm } from './components/formUtils';

export const Edit: React.FC = () => {
  const [isLoading, setIsLoading] = React.useState(false);
  const { item } = useAppSelector(state => state.articles);
  const { b2cUrl } = useAppSelector(state => state.configSlice);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { id } = useParams();

  React.useEffect(() => {
    dispatch(loadArticlesItem(id));
  }, []);

  const onFinish = (values: IArticlesItem) => {
    setIsLoading(true);
    dispatch(saveArticlesItem({ ...values, id: item.id }))
      .unwrap()
      .then(() => {
        notification.success({
          message: 'Сущность успешно изменена',
        });
        navigate('/articles');
      })
      .catch(() => setIsLoading(false));
  };

  const onSaveDraft = (values: IArticlesItem) => {
    setIsLoading(true);
    dispatch(saveArticlesItemAsDraft({ ...values, id: item.id }))
      .unwrap()
      .then(() => {
        notification.success({
          message: 'Сущность успешно изменена',
        });
        navigate('/articles');
      })
      .catch(() => setIsLoading(false));
  };

  const cancelButtonHandler = () => {
    navigate('/articles');
  };

  const getOgSiteName = () => {
    if (!item) return null;

    const sysName = item.sysName || '';
    const linkToB2C =
      item.lang === 'en'
        ? `${b2cUrl}/en/articles/${id}/${sysName}`
        : `${b2cUrl}/articles/${id}/${sysName}`;

    return linkToB2C;
  };

  return (
    <MainLayout pageTitle='Редактирование'>
      {item.id && item.id === Number(id) ? (
        <ArticlesForm
          onFinish={onFinish}
          onSaveDraft={onSaveDraft}
          cancelButtonHandler={cancelButtonHandler}
          isDraft={item.status === 'draft'}
          isLoading={isLoading}
          initialValues={{
            ...mapValuesToForm(item),
            ogUrl: getOgSiteName(),
            ogSiteName: 'Посети Кавказ',
            ogType: 'article',
          }}
        />
      ) : null}
    </MainLayout>
  );
};
